export default [
    {
        path: '/shared',
        redirect: '/',
    },
];
